import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IconWithText } from "../icon-with-text/IconWithText";
import { getResourceIcon } from "../icon/getResourceIcon";
import { NumberFormat } from "../number-format/NumberFormat";
export var Resource = function (_a) {
    var resource = _a.resource, backgroundClassName = _a.backgroundClassName, backgroundSize = _a.backgroundSize, styleId = _a.styleId, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.centerText, centerText = _c === void 0 ? true : _c;
    var icon = getResourceIcon(resource);
    var iconStyle = styleId ? styleId : IdStyles.IconSmall;
    return (React.createElement(IconWithText, { icon: icon, styleId: iconStyle, className: className, backgroundClassName: backgroundClassName, backgroundSize: backgroundSize, centerText: centerText },
        React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: resource.amount })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/resource/Resource.tsx
// module id = 889
// module chunks = 3